module.exports = __webpack_public_path__ + "img/Grejanje_MAZUT.6e80d418.svg";